module.exports = __webpack_public_path__ + "static/media/theoretical.a7373c05.svg";